export default {
	background: 'white',
	color: 'black',
	accent: '#007a3d',
	complementary: '#ce1126',
	clearcolor: 'white',
	darkcolor: 'black',
	fontbody: '"Acta", Helvetica, Arial, sans-serif',
	fonttitle: '"Acta", Helvetica, Arial, sans-serif',
	fonttitle2: '"Acta", Helvetica, Arial, sans-serif',
	fonttitle3: '"Acta", Helvetica, Arial, sans-serif',
	fonttitlesize: '5.25rem',
	fontsize: '1.25rem',
	lineheight: '1.42857',
	titleheight: '1',
	normalWidth: '600px',
	maxWidth: '1200px',
	overWidth: '1440px',
	headerHeight: '5rem',
	spacing: '2rem',
	button: {
		backgroundColor: '#dbdec1',
		color: 'black',
		borderRadius: '4px',
		padding: '1rem 2rem'
	},
	strong: {
		weight: 800
	}
};
